var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import moment from 'moment';
import Component from 'vue-class-component';
import { Prop } from "vue-property-decorator";
var initFormData = {
    keyword: '',
    log_type: 0,
    s_time: moment().subtract(30, 'days').format('YYYY-MM-DD'),
    e_time: moment().format('YYYY-MM-DD')
};
var BillHeader = (function (_super) {
    __extends(BillHeader, _super);
    function BillHeader() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formData = __assign({}, initFormData);
        return _this;
    }
    BillHeader.prototype.search = function () {
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.reset = function () {
        this.formData = __assign({}, initFormData);
        this.$emit('search', __assign({}, this.formData));
    };
    BillHeader.prototype.exportData = function () {
        this.$emit('export', __assign({}, this.formData));
    };
    __decorate([
        Prop({
            required: true,
            type: Array
        })
    ], BillHeader.prototype, "typeList", void 0);
    BillHeader = __decorate([
        Component({
            computed: {
                dateRange: {
                    get: function () {
                        var _a = this.formData, s_time = _a.s_time, e_time = _a.e_time;
                        return [s_time, e_time];
                    },
                    set: function (val) {
                        if (val === void 0) { val = []; }
                        this.formData.s_time = val[0];
                        this.formData.e_time = val[1];
                    }
                }
            }
        })
    ], BillHeader);
    return BillHeader;
}(Vue));
export default BillHeader;
